import axios from "../../index";
import api from "./MarkCenter.api";

export default {
  // 实训目录-实训数据集详情
  /**
   * 新增数据集  @data {
      "datasetDescribe": "string", // 数据集描述
      "datasetName": "string", // 数据集名称
      "trainingId": "string" // 实训id
     }
   */
  addDataset(data = {}) {
      return axios.post(api.addDataset, data);
  },
  /**
   * 通过实训id获取数据集信息  @data {trainingId: "string" // 实训id}
   */
  getDatasetByTrainingId(data = {}) {
      return axios.post(api.getDatasetByTrainingId, data);
  },
  /**
   * 通过数据集id获取数据集状态  @data {datasetId："string" // 数据集id}
   */
  getDatasetStatusByDatasetId(data = {}) {
      return axios.post(api.getDatasetStatusByDatasetId, data);
  },
  /**
   * 新增标签  @data {datasetId: "数据集id", labelName: "标签名称"}
   */
  addDatasetLabel(data = {}) {
      return axios.post(api.addDatasetLabel, data);
  },
  /**
   * 通过数据集id获取标签  @data {datasetId: "数据集id"}
   */
  getLabelByDatasetId(data = {}) {
      return axios.post(api.getLabelByDatasetId, data);
  },
  /**
   * 修改标签  @data {datasetId: "数据集id", labelId: "标签id", labelName: "标签名称"}
   */
  updateDatasetLabel(data = {}) {
      return axios.post(api.updateDatasetLabel, data);
  },
  /**
   * 删除标签  @data {datasetId: "数据集id", labelId: "标签id", labelName: "标签名称"}
   */
  deleteDatasetLabel(data = {}) {
      return axios.post(api.deleteDatasetLabel, data);
  },
  /**
   * 上传文件  @data {
      tenantId: 0, // 租户id,
      datasetId: "string", // 数据集id
      labelId: "string", // 标签id
      list: [
        {
          fileName: "string", // 文件名称
          fileUrl: "string", // 文件url
        }
      ]
    }
   */
  addDatasetFile(data = {}) {
      return axios.post(api.addDatasetFile, data);
  },
  /**
   * 通过标签id获取图片  @data {
      datasetId: "string", // 数据集id
      isTag: 0, // 是否标注 1:已标注;0:未标注（图像分类图片不需要设置标注，全部为0）
      labelId: "string", // 标签id
      pageNum: 1, // 当前页数
      pageSize: 10 // 每页条数
    }
   */
  getFileByLabelId(data = {}) {
      return axios.post(api.getFileByLabelId, data);
  },
  /**
   * 修改文件  @data { fileId: "文件id", fileName: "文件名称" }
   */
  updateDatasetFile(data = {}) {
      return axios.post(api.updateDatasetFile, data);
  },
  /**
   * 删除文件  @data { fileId: "文件id", fileName: "文件名称" }
   */
  deleteDatasetFile(data = {}) {
      return axios.post(api.deleteDatasetFile, data);
  },
  /**
   * 上传目标文件  @data {
      trainingId: "string", // 实训id
      labelId: "string", // 标签id
      list: [
        {
          fileName: "string", // 文件名称
          fileUrl: "string" // 文件url
        }
      ],
    }
   */
  addTrainingTargetFile(data = {}) {
      return axios.post(api.addTrainingTargetFile, data);
  },
  /**
   * 通过实训id获取目标文件  @data { trainingId: "实训id" }
   */
  getTargetFileByTraining(data = {}) {
      return axios.post(api.getTargetFileByTraining, data);
  },
  /**
   * 修改目标文件  @data { fileId: "文件id", fileName: "文件名称" }
   */
  updateTrainingTargetFile(data = {}) {
      return axios.post(api.updateTrainingTargetFile, data);
  },
  /**
   * 删除目标文件  @data { fileId: "文件id", fileName: "文件名称" }
   */
  deleteTrainingTargetFile(data = {}) {
      return axios.post(api.deleteTrainingTargetFile, data);
  },
  /**
   * 创建模型  @data {
      modelDescribe: "string", // 模型描述
      modelName: "string", // 模型名称
      trainingId: "string" // 实训id
    }
   */
  insertModel(data = {}) {
      return axios.post(api.insertModel, data);
  },
  /**
   * 获取模型  @data { trainingId: "实训id", userId: 用户id }
   */
  getModelByTrainingId(data = {}) {
      return axios.post(api.getModelByTrainingId, data);
  },
  /**
   * 根据数据集id查询标签下的数量  @data { datasetId: "数据集id" }
   */
  getLabelNumByDatasetId(data = {}) {
      return axios.post(api.getLabelNumByDatasetId, data);
  },
  /**
   * 新增训练模型  @data {
      datasetId: "string", // 数据集id
      labelIds: "string", // 标签id集合
      labelNames: "string", // 标签名称集合
      modelId: "string", // 模型id
      modelType: 0, // 模型类型
      trainingId: "string" // 实训id
      tenantId: 0, // 租户id(调接口统一已传)
    }
   */
  addTrainModel(data = {}) {
      return axios.post(api.addTrainModel, data);
  },
  /**
   * 查询训练模型版本信息  @data { modelId: "模型id" }
   */
  getTrainModelByModelId(data = {}) {
      return axios.post(api.getTrainModelByModelId, data);
  },
  /**
   * 删除训练模型  @data {
      trainingId: "string", // 实训id
      trainModelId: "string", // 训练模型id
      trainModelStatus: 0, // 训练模型状态：1:进行中;2:训练完成;3:已发布;4:已下线
    }
   */
  deleteTrainingModel(data = {}) {
      return axios.post(api.deleteTrainingModel, data);
  },
  /**
   * 发布训练模型  @data { trainingId: "实训id", trainModelId: "训练模型id" }
   */
  releaseTrainModel(data = {}) {
      return axios.post(api.releaseTrainModel, data);
  },
  /**
   * 校验模型  @data {  }
   */
  verifyModel(data = {}) {
      return axios.post(api.verifyModel, data);
  },
  /**
   * 老师查看学生校验结果、学生查看老师校验结果  @data { trainModelId：'训练模型id' }
   */
  getCheckDataByTrainModelId(data = {}) {
      return axios.post(api.getCheckDataByTrainModelId, data);
  },

  // 物体检测-标注数据接口 //
  /**
   * 通过数据集id获取文件  @data { 
      editorType: '编辑类型',
      datasetId: '训练模型id',
      isTag: '是否标注 0:未标注,1:已标注,2:所有',
      pageNum: 1,
      pageSize: 20,
    }
   */
  getFileByDatasetId(data = {}) {
    return axios.post(api.getFileByDatasetId, data);
  },
  /**
   * 根据标签ids查询文件列表  @data { 
      editorType: '编辑类型',
      datasetId: '训练模型id',
      labelIdList: [], // 标签id集合
      pageNum: 1,
      pageSize: 20,
    }
   */
  getFileByLabelIds(data = {}) {
    return axios.post(api.getFileByLabelIds, data);
  },
  /**
   * 根据图片id查询图片标注数据  @data { imgId: '图片id', labelIds: [], //标签ids }
   */
  getImgTagByImgId(data = {}) {
    return axios.post(api.getImgTagByImgId, data);
  },
  /**
   * 根据图片id标注图片  @data {}
   */
  updateImgTagByImgId(data = {}) {
    return axios.post(api.updateImgTagByImgId, data);
  },
  /**
   * 根据标签id查询标注数量  @data { 
      editorType: '编辑类型',
      datasetId: '训练模型id',
      labelIdList: [], // 标签id集合
    }
   */
  getTagNumByLabelIds(data = {}) {
    return axios.post(api.getTagNumByLabelIds, data);
  },

  // 实训作业接口 //
  /**
   * 通过实训id获取项目作业数据  @data "trainingId":"实训id", "curriculumId": "课程id", "pageNum": 1 '必填,当前页数', "pageSize": 10 '必填,每页条数',
   */
  getTaskByTrainingId(data = {}) {
    return axios.post(api.getTaskByTrainingId, data);
  },
  /**
   * 查询基础项目作业详情数据  @data userId trainingId
   */
  getTaskInfoByTrainingId(data = {}) {
    return axios.post(api.getTaskInfoByTrainingId, data);
  },
  /**
   * 老师评价学生已提交项目  @data
   */
  evaluationProByTeacher(data = {}) {
    return axios.post(api.evaluationProByTeacher, data);
  },
  /**
   * 数据标注项目添加学生自评  @data
   */
  saveEvaluation(data = {}) {
    return axios.post(api.saveEvaluation, data);
  },
  /**
   * 实训报告  @data trainingId 项目id  userId
   */
  getTrainingReport(data = {}) {
    return axios.post(api.getTrainingReport, data);
  },

  // 实训考核接口 //
  /**
   * 添加项目考核标准  @data {
      "assessList": [
        {
          "automaticScoringState": 0, // 自动评分状态：0为不自动评分，1为自动评分
          "checkData": "string", // 校验结果
          "customValue": "string", // 自定义考核内容
          "keywordList": [{}], // 得分关键词
          "scoreProportion": 0, // 分数比例
          "type": 0 // 类型：1为流程；2为数据集；3为标签；4为模型；5为指标；6为校验结果；7为自定义
        }
      ],
      "tenantId": 0, // 租户id
      "trainingId": "string" // 实训id
    }
   */
  addTrainingCheck(data = {}) {
    return axios.post(api.addTrainingCheck, data);
  },
  /**
   * 老师查看项目考核标准  @data {tenantId: "租户id", trainingId: "实训id", editorType:"类型"} 
   */
  getTrainingCheck(data = {}) {
    return axios.post(api.getTrainingCheck, data);
  },
  /**
   * 学生查看实训考核  @data {tenantId: "租户id", trainingId: "实训id"} 
   */
  getTrainingCheckByStudent(data = {}) {
    return axios.post(api.getTrainingCheckByStudent, data);
  },
  /**
   * 删除项目考核标准  @data {tenantId: "租户id", trainingId: "实训id"} 
   */
  deleteTrainingCheck(data = {}) {
    return axios.post(api.deleteTrainingCheck, data);
  },
  /**
   * 老师、学生查看评分实训考核结果  @data {
      trainingId: "实训id",
      editorType: "类型",
      teacherId: "老师id",
      studentId: "学生id",
    } 
   */
  getTrainingAssessReport(data = {}) {
    return axios.post(api.getTrainingAssessReport, data);
  },
  /**
   * 已设置实训考核-老师评分  @data {trainingId: "实训id", editorType:"类型"} 
   */
  evaluationAssessByTeacher(data = {}) {
    return axios.post(api.evaluationAssessByTeacher, data);
  },
};
